const hasFocusedTag = ({ state, props, path }) => {
  const focusedTag = state.get(`selectr.${props.namespace}.focusedTag`)
  if (focusedTag === null) {
    return path.false()
  } else {
    return path.true({ focusedTag })
  }
}

hasFocusedTag.displayName = 'hasFocusedTag'
export default hasFocusedTag
